import axios from 'axios';

// Set the base URL dynamically based on the environment

const apiPrefix = '/ws';
const baseURL =
  process.env.NODE_ENV === 'production'
    ? apiPrefix
    : // this is to hit api from local to staging server
      `https://staging.app.thalamushq.ai${apiPrefix}`;

// Create an Axios instance
const socketClient = axios.create({
  baseURL, // Automatically prefixes all requests with this URL
  withCredentials: true, // Ensures cookies are sent
});

// socketClient.interceptors.response.use(
//   (response) => {
//     // Middleware logic: Check if a certain response is sent
//     if (response.data?.force_redirect) {
//       window.location.href = response.data.redirection_params.location; // Handle redirect
//       return Promise.reject("Redirecting..."); // Prevent further execution
//     }

//     return response; // If no special condition, pass response to the caller
//   },  
//   (error) => {
//     console.error("Interceptor Error:", error);

//     console.log("Error:", error?.response?.data?.error);
//     if (error.response && (error.response?.status === 500 || error.response?.status === 429)) {
//       alert(`${error.response.data.error}`);
//     } else {
//       alert(error.message);
//     }
//     return Promise.reject(error); // Pass error to caller
//   }
// );

export default socketClient;
